import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
    const location = useLocation();

    const getLinkClass = (path: string) =>
        (location.pathname === path || (path === '/about' && location.pathname === '/'))
            ? 'inline-block p-4 text-white border-b-2 border-white rounded-t-lg active text-white border-white font-bold'
            : 'inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-300';

    return (
        <div className='mx-auto md:mx-6 lg:mx-20 text-xs md:text-sm font-light text-center text-lightGrey border-b-2 border-grey max-w-max lg:mt-16'>
            <ul className='flex flex-wrap -mb-[2px]'>
                <li className='me-2'>
                    <Link to='/about' className={getLinkClass('/about')}>About</Link>
                </li>
                <li className='me-2'>
                    <Link to='/services' className={getLinkClass('/services')}>Services</Link>
                </li>
                <li>
                    <Link to='/contact' className={getLinkClass('/contact')}>Contact</Link>
                </li>
            </ul>
        </div>
    );
};

export default Navbar;